import { TaskControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
export const useArchiveTask = () =>
  useMutationWithLoading(
    async (param: { taskId: string; status: boolean; xTENANTID?: string }) =>
      new TaskControllerApi(getConfigObject()).updateTaskArchiveStatus(
        param.taskId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
